export class GuildPowerStatsDTO {
  constructor() {
    this.total_fuel = null;
    this.total_load = null;
    this.total_capacity = null;
    this.avg_connection_capacity = null;
  }
}